<div class="sidenav__header">
    <div class="sidenav__logo">
        <img [src]="'images/' + (collapsed() ? 'ministry-logo-icon' : 'ministry-logo') + '.svg'" alt="" />
    </div>
    <button
        class="sidenav__toggle-button"
        [class.sidenav__toggle-button--collapsed]="collapsed()"
        (click)="collapsed.set(!collapsed())"
    >
        <img src="images/toggle.svg" alt="icon" />
    </button>
</div>

<mat-nav-list [disableRipple]="true" class="sidenav__nav-list">
    @for (item of menuItems(); track item.label) {
        <pims-menu-item [item]="item" [collapsed]="collapsed()" [level]="0" />
    }
</mat-nav-list>
